module.exports = __webpack_public_path__ + "static/media/shubhamprakash2.9ad656bd.png";